import type { Lang, Localized } from '../types/funnel';

/**
 * SMS consent disclosures (A2P). Exact text is versioned: if any wording changes, bump the version
 * so every stored record points to the text the customer actually saw.
 */
export const CONSENT_TEXT_VERSION = '2026-10-06';

export const smsDisclosures: { marketing: Localized; nonMarketing: Localized; optionalNote: Localized } = {
  marketing: {
    en: 'I consent to receive marketing text messages about moving service offers, discounts, and promotional follow-up from InstaMovers Florida LLC at the phone number provided. Message frequency varies. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.',
    es: 'Acepto recibir mensajes de texto de marketing sobre ofertas de servicios de mudanza, descuentos y seguimiento promocional de InstaMovers Florida LLC al número de teléfono proporcionado. La frecuencia de los mensajes varía. Pueden aplicar tarifas de mensajes y datos. Envíe HELP para obtener ayuda, responda STOP para cancelar.',
  },
  nonMarketing: {
    en: 'I consent to receive non-marketing text messages from InstaMovers Florida LLC about my requested moving quote, booking confirmations, appointment coordination, and moving service updates. Message frequency varies. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.',
    es: 'Acepto recibir mensajes de texto que no son de marketing de InstaMovers Florida LLC sobre mi cotización de mudanza solicitada, confirmaciones de reserva, coordinación de citas y actualizaciones del servicio de mudanza. La frecuencia de los mensajes varía. Pueden aplicar tarifas de mensajes y datos. Envíe HELP para obtener ayuda, responda STOP para cancelar.',
  },
  optionalNote: {
    en: 'SMS consent is optional and is not a condition of purchase. You can request a quote without agreeing to text messages.',
    es: 'El consentimiento para SMS es opcional y no es una condición de compra. Puede solicitar una cotización sin aceptar mensajes de texto.',
  },
};

export interface SmsConsentRecord {
  sms_marketing_consent: boolean;
  sms_nonmarketing_consent: boolean;
  /** Must be set by the server (UTC) when it receives the submission. Never trusted from the browser. */
  consent_timestamp: null;
  consent_source_url: string;
  consent_text_version: string;
  consent_language: Lang;
  consent_disclosure: { marketing: string; nonmarketing: string; optional_note: string };
}

/** Builds the record from the two checkboxes only. A phone number, quote request or other consent never sets these to true. */
export function buildSmsConsentRecord(marketing: boolean, nonMarketing: boolean, lang: Lang): SmsConsentRecord {
  return {
    sms_marketing_consent: marketing === true,
    sms_nonmarketing_consent: nonMarketing === true,
    consent_timestamp: null,
    consent_source_url: typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : '',
    consent_text_version: CONSENT_TEXT_VERSION,
    consent_language: lang,
    consent_disclosure: {
      marketing: smsDisclosures.marketing[lang],
      nonmarketing: smsDisclosures.nonMarketing[lang],
      optional_note: smsDisclosures.optionalNote[lang],
    },
  };
}
